import { useMutation } from "@tanstack/react-query";
import { useData } from "../../runtime/provider";
import { NoAuthError } from "@utils/NoAuthError";
import type { RouterInputs } from "../../data/core/trpc";
import { USER_ME_QUERY_KEY, UserMeQueryData } from "./useMe";

type Input = RouterInputs["user"]["markOnboardingCompleted"];

export const useMarkOnboardingCompleted = () => {
  const data = useData();
  const { queryClient, auth } = data;
  return useMutation({
    mutationFn: (input: Input) => {
      if (!auth.currentUser()) {
        throw new NoAuthError("useMarkOnboardingCompleted mutationFn");
      }
      return data.api.user.markOnboardingCompleted.mutate(input);
    },
    onSuccess: () => {
      // Durable write-through: the optimistic update lands in BOTH the
      // in-memory react-query cache AND the SQLite query_cache so that a
      // kill-and-relaunch (or a follow-up refetch on bad internet) can't
      // visually un-onboard the user.
      data.cache.setQueryDataDurable<UserMeQueryData>(
        queryClient,
        USER_ME_QUERY_KEY,
        (old) => {
          if (!old) return old;
          return { ...old, onboarded: true };
        },
      );
    },
  });
};
